/**
 * COSMIC 9 GEMS — Sell Your Gemstone
 *
 * Presentation only. The enquiry form itself is Shopify's `{% form 'contact' %}`
 * and is submitted by the browser to Shopify, so there is deliberately no
 * script here that intercepts a submit, builds a payload or calls an endpoint.
 * Field validation is the browser's own `required` / `type` / `pattern`
 * handling, which cannot fail open the way a fetch can.
 *
 * What is left is the hero: a parallax drift on the photograph and the gold
 * rule that draws in once on arrival.
 */
(function () {
  'use strict';

  /**
   * The drift is written to a custom property and applied by CSS, so the
   * effect is opt-out in one place: the reduced-motion block in c9-sell.css
   * sets transform:none and this loop becomes inert rather than fighting it.
   * The listener is passive and the write is inside rAF, so it cannot block
   * scrolling or force layout mid-gesture.
   */
  function heroes(scope) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var list = (scope || document).querySelectorAll('[data-c9-sellhero]');

    Array.prototype.forEach.call(list, function (hero) {
      if (hero.c9HeroReady) return;
      hero.c9HeroReady = true;

      /* Draws the rule. Deferred a frame so the transition has a start state
         to animate from rather than being applied at paint. */
      requestAnimationFrame(function () {
        hero.classList.add('is-revealed');
      });

      var media = hero.querySelector('[data-c9-sellhero-media]');
      if (!media || reduce.matches) return;

      var ticking = false;

      function update() {
        ticking = false;
        var box = hero.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        /* Capped so the scaled image can never expose an edge. */
        var shift = Math.max(-40, Math.min(40, -box.top * 0.08));
        media.style.setProperty('--c9-sellhero-shift', shift.toFixed(2) + 'px');
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      heroes(document);
    });
  } else {
    heroes(document);
  }

  /* Theme editor re-renders a section's markup wholesale, so a freshly
     dropped section has to be wired up again. */
  document.addEventListener('shopify:section:load', function (e) {
    heroes(e.target);
  });
})();
